var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex-link",class:{'pointer-events-none': !_vm.link.url, 'router-link-active': _vm.isActive},attrs:{"href":_vm.linkUrl,"target":_vm.link.target ? '_blank' : ''},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }